import { render, staticRenderFns } from "./flowingWater.vue?vue&type=template&id=4bb8a9f6"
import script from "./flowingWater.vue?vue&type=script&lang=js"
export * from "./flowingWater.vue?vue&type=script&lang=js"
import style0 from "./flowingWater.vue?vue&type=style&index=0&id=4bb8a9f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports